import { supabase } from '../config/supabaseClient'
import { Reply } from '../types'
export const saveReplyToDatabase = async (
  reply: Omit<Reply, 'hasVoted'>,
): Promise<void> => {
  const { error } = await supabase.from('replies').insert({
    rant_id: reply.rantId,
    text: reply.text,
    display_name: 'Anonymous',
  })
  if (error) {
    console.error('Error saving reply:', error)
    throw error
  }
}
export const getRepliesForRant = async (rantId: string): Promise<Reply[]> => {
  const { data, error } = await supabase
    .from('replies')
    .select('*')
    .eq('rant_id', rantId)
    .order('timestamp', { ascending: true })
  if (error) {
    console.error('Error fetching replies:', error)
    return []
  }
  const votedReplies = getVotedRepliesFromLocalStorage()
  return data.map((row) => ({
    id: row.id,
    rantId: row.rant_id,
    text: row.text,
    votes: row.votes,
    timestamp: new Date(row.timestamp).getTime(),
    hasVoted: votedReplies.includes(row.id),
  }))
}
export const getReplyCountForRant = async (rantId: string): Promise<number> => {
  const { count, error } = await supabase
    .from('replies')
    .select('*', { count: 'exact', head: true })
    .eq('rant_id', rantId)
  if (error) {
    console.error('Error fetching reply count:', error)
    return 0
  }
  return count || 0
}
export const updateReplyVote = async (replyId: string): Promise<void> => {
  const { data, error: fetchError } = await supabase
    .from('replies')
    .select('votes')
    .eq('id', replyId)
    .single()
  if (fetchError) {
    console.error('Error fetching reply:', fetchError)
    throw fetchError
  }
  const { error: updateError } = await supabase
    .from('replies')
    .update({ votes: data.votes + 1 })
    .eq('id', replyId)
  if (updateError) {
    console.error('Error updating reply votes:', updateError)
    throw updateError
  }
  saveVotedReplyToLocalStorage(replyId)
}
const getVotedRepliesFromLocalStorage = (): string[] => {
  const voted = localStorage.getItem('votedReplies')
  return voted ? JSON.parse(voted) : []
}
const saveVotedReplyToLocalStorage = (replyId: string): void => {
  const voted = getVotedRepliesFromLocalStorage()
  if (!voted.includes(replyId)) {
    voted.push(replyId)
    localStorage.setItem('votedReplies', JSON.stringify(voted))
  }
}
